import React, { FC } from "react";
import { createIntl, RawIntlProvider } from "react-intl";
import { plMessages } from "../translations/pl";

export let t = (id: string, values?: any) => "preparing translations...";

export const PreparedIntlProvider: FC = props => {
  const intl = createIntl({ locale: "pl-PL", messages: plMessages });

  t = (id: string, values?: any) => {
    if (intl.messages[id]) return intl.formatMessage({ id }, values);
    else return id;
  };

  return <RawIntlProvider value={intl}>{props.children}</RawIntlProvider>;
};
